import React from 'react'

const Commercial = () => {
    return (
        <div>
            <h1>Commercial Page</h1>
        </div>
    )
}

export default Commercial